import Vue from 'vue'

export default new Vue({
  methods: {
    emitSelectionUpdate ($event) {
      this.$emit('selection-update', $event)
    },
    onSelectionUpdate (func) {
      this.$on('selection-update', func)
    }
  }
})
